import { render, staticRenderFns } from "./ImagemListModal.vue?vue&type=template&id=459ea726&scoped=true"
import script from "./ImagemListModal.vue?vue&type=script&lang=js"
export * from "./ImagemListModal.vue?vue&type=script&lang=js"
import style0 from "./ImagemListModal.vue?vue&type=style&index=0&id=459ea726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459ea726",
  null
  
)

export default component.exports